if (document.querySelector('.btn-print')) {
    document.addEventListener('DOMContentLoaded', () => {
        const printBtn = document.querySelector('.btn-print');
        
        if (printBtn) {
            printBtn.addEventListener('click', (e) => {
                e.preventDefault();
                
                const title = document.querySelector('.title')?.textContent || '';
                const date = document.querySelector('.block-statistics__date')?.textContent || '';
                const textContent = document.querySelector('.block-text')?.cloneNode(true);

                if (textContent) {
                    const elementsToRemove = textContent.querySelectorAll('img, video, audio, iframe, .block-video, .social-link, .btn-print');
                    elementsToRemove.forEach(el => el.remove());
                }

                const printContent = `<!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="utf-8">
                        <style>
                            @page { margin: 20mm 15mm; }
                            body { 
                                font-family: Arial, sans-serif;
                                line-height: 1.4;
                                margin: 0;
                                padding: 20px 30px;
                            }
                            h1 { 
                                font-size: 24px;
                                margin: 0 0 15px;
                            }
                            .date { 
                                color: #6E6E6E;
                                margin-bottom: 20px;
                                font-size: 14px;
                            }
                            .content {
                                margin-bottom: 20px;
                            }
                        </style>
                    </head>
                    <body>
                        <h1>${title}</h1>
                        <div class="date">${date}</div>
                        <div class="content">${textContent?.innerHTML || ''}</div>
                    </body>
                    </html>`;

                const printWindow = window.open('', '', 'height=600,width=800');
                printWindow.document.write(printContent);
                printWindow.document.close();
                
                printWindow.onload = function() {
                    printWindow.document.title = '';
                    printWindow.print();
                    printWindow.onafterprint = () => printWindow.close();
                };
            });
        }
    });
}